import { render, staticRenderFns } from "./TrashProducts.vue?vue&type=template&id=97b72c3e&"
import script from "./TrashProducts.vue?vue&type=script&lang=js&"
export * from "./TrashProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97b72c3e')) {
      api.createRecord('97b72c3e', component.options)
    } else {
      api.reload('97b72c3e', component.options)
    }
    module.hot.accept("./TrashProducts.vue?vue&type=template&id=97b72c3e&", function () {
      api.rerender('97b72c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/TrashProducts.vue"
export default component.exports